import React, { useLayoutEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";


import UserDetailsRegular from "../pages/pre-built/user-manage/UserDetailsRegular";
import ES1Data from "../pages/pre-built/user-manage/ES1Data";
import ES2Data from "../pages/pre-built/user-manage/ES2Data";
import ES3Data from "../pages/pre-built/user-manage/ES3Data";
import ES4Data from "../pages/pre-built/user-manage/ES4Data";
import ES5PA1Data from "../pages/pre-built/user-manage/ES5PA1Data";
import ES5PA2Data from "../pages/pre-built/user-manage/ES5PA2Data";
import ES1DataView from "../pages/pre-built/user-manage/ES1DataView";
import ES2DataView from "../pages/pre-built/user-manage/ES2DataView";
import ES3DataView from "../pages/pre-built/user-manage/ES3DataView";
import ES4DataView from "../pages/pre-built/user-manage/ES4DataView";
import ES5PA1DataView from "../pages/pre-built/user-manage/ES5PA1DataView";
import ES5PA2DataView from "../pages/pre-built/user-manage/ES5PA2DataView";
import ES27RevisedData from "../pages/pre-built/user-manage/ES27RevisedData";
import ES3RevisedData from "../pages/pre-built/user-manage/ES3RevisedData";
import ES6Data from "../pages/pre-built/user-manage/ES6Data";
import ES3RevisedView from "../pages/pre-built/user-manage/ES3RevisedView";
import ES27RevisedView from "../pages/pre-built/user-manage/ES27RevisedView";
import ES6View from "../pages/pre-built/user-manage/ES6View";
import ER1Data from "../pages/pre-built/user-manage/ER/ER1Data";
import ER2Data from "../pages/pre-built/user-manage/ER/ER2Data";
import DGEDashboard from "../pages/pre-built/user-manage/DGEDashboard";
import ReasonalDashbard from "../pages/pre-built/user-manage/ReasonalDashbard";
import StateDashboard from "../pages/pre-built/user-manage/StateDashboard";
import AddDetail from "../pages/pre-built/user-manage/AddDetail";
import RegionDetail from "../pages/pre-built/user-manage/RegionDetail";
import District from "../pages/pre-built/user-manage/District";
import AdminEmployemtCount from "../pages/pre-built/user-manage/AdminEmployemtCount";
import ES1DataEdit from "../pages/pre-built/user-manage/ES1DataEdit";
import ES27RevisedEdit from "../pages/pre-built/user-manage/ES27RevisedEdit";
import ES3DataEdit from "../pages/pre-built/user-manage/ES3DataEdit";
import ES3RevisedEdit from "../pages/pre-built/user-manage/ES3RevisedEdit";
import ES4DataEdit from "../pages/pre-built/user-manage/ES4DataEdit";
import ES5PA1DataEdit from "../pages/pre-built/user-manage/ES5PA1DataEdit";
import ES5PA2DataEdit from "../pages/pre-built/user-manage/ES5PA2DataEdit";
import ES6Edit from "../pages/pre-built/user-manage/ES6Edit";
import ES2DataEdit from "../pages/pre-built/user-manage/ES2DataEdit";
import Recheck from "../pages/pre-built/user-manage/Recheck";
import ES3DataReport from "../pages/pre-built/user-manage/Report/ES3DataReport";
import ES4DataReport from "../pages/pre-built/user-manage/Report/ES4DataReport";
import ES1DataReport from "../pages/pre-built/user-manage/Report/ES1DataReport";
import ES2DataReport from "../pages/pre-built/user-manage/Report/ES2DataReport";
import ES5part1DataReport from "../pages/pre-built/user-manage/Report/ES5part1DataReport";
import ES5part2DataReport from "../pages/pre-built/user-manage/Report/ES5part2DataReport";
import ES6DataReport from "../pages/pre-built/user-manage/Report/ES6DataReport";
import ES7DataReport from "../pages/pre-built/user-manage/Report/ES7DataReport";
import ES8DataReport from "../pages/pre-built/user-manage/Report/ES8DataReport";
import CPDashboard from "../pages/pre-built/user-manage/CP/CPDashboard/CPDashboard";
import CPData from "../pages/pre-built/user-manage/CP/CPData";
import CPEditForm from "../pages/pre-built/user-manage/CP/CPEditForm";
import CPFormView from "../pages/pre-built/user-manage/CP/CPFormView";
import CPDGEDashboard from "../pages/pre-built/user-manage/CP/CPDGEDashboard/CPDGEDashboard";
import CPReasonalDashbard from "../pages/pre-built/user-manage/CP/CPRegionalDashboard/CPReasonalDashbard";
import CPStateDashboard from "../pages/pre-built/user-manage/CP/CPStateDashboard/CPStateDashboard";
import ER1DataView from "../pages/pre-built/user-manage/ER/ER1DataView";
import ER2DataView from "../pages/pre-built/user-manage/ER/ER2DataView";
import ERDashboard from "../pages/pre-built/user-manage/ER/ERUSERADMINDASH/ERDashboard";
import ER2DataEdit from "../pages/pre-built/user-manage/ER/ER2DataEdit";
import ERDGEDashboard from "../pages/pre-built/user-manage/ER/ERDGEDashboard/ERDGEDashboard";
import ERStateDashboard from "../pages/pre-built/user-manage/ER/ERStateDashboard/ERStateDashboard";
import ERReasonalDashbard from "../pages/pre-built/user-manage/ER/ERRegionalDashboard/ERReasonalDashbard";
import ER1DataEdit from "../pages/pre-built/user-manage/ER/ER1DataEdit";
import ES3DataReportNew from "../pages/pre-built/user-manage/Report/ES3DataReportNew";
import CP1MisReport from "../pages/pre-built/user-manage/CP/CPMISReport/cp1MisReport";
import RecheckCP from "../pages/pre-built/user-manage/CP/CPMISReport/RecheckCP";
import { SummaryReport } from "../pages/pre-built/user-manage/Report/SummaryReport";
import ES1DataNew from "../pages/pre-built/user-manage/ES1DataNew";
import ES2DataNew from "../pages/pre-built/user-manage/ES2DataNew";



const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (

    <Switch>
      {/*Dashboards*/}
      <Route exact path={`${process.env.PUBLIC_URL}/ES1`} component={ES1Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES1-New`} component={ES1DataNew}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES1-View`} component={ES1DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES1-Edit`} component={ES1DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES2`} component={ES2Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES27R`} component={ES27RevisedData}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES27R-View`} component={ES27RevisedView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES27R-Edit`} component={ES27RevisedEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES2-View`} component={ES2DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES2-Edit`} component={ES2DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES2-New`} component={ES2DataNew}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3`} component={ES3Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3R`} component={ES3RevisedData}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3R-View`} component={ES3RevisedView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3R-Edit`} component={ES3RevisedEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3-View`} component={ES3DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3-Edit`} component={ES3DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES4`} component={ES4Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES4-View`} component={ES4DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES4-Edit`} component={ES4DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part1`} component={ES5PA1Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part1-View`} component={ES5PA1DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part1-Edit`} component={ES5PA1DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part2`} component={ES5PA2Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part2-View`} component={ES5PA2DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part2-Edit`} component={ES5PA2DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES6`} component={ES6Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES6-View`} component={ES6View}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES6-Edit`} component={ES6Edit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Dashboard`} component={UserDetailsRegular}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/DGEDashboard`} component={DGEDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Reasonal-Dashboard`} component={ReasonalDashbard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/State-Dashboard`} component={StateDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Add-Detail`} component={AddDetail}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Region-Detail`} component={RegionDetail}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/District-Detail`} component={District}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/AdminEmployemtCount`} component={AdminEmployemtCount}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/summaryReport`} component={SummaryReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Recheck`} component={Recheck}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3Report`} component={ES3DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES4Report`} component={ES4DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES1Report`} component={ES1DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES2Report`} component={ES2DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part1Report`} component={ES5part1DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES5Part2Report`} component={ES5part2DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES6DataReport`} component={ES6DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES7DataReport`} component={ES7DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES8DataReport`} component={ES8DataReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ES3DataReportNew`} component={ES3DataReportNew}></Route>

      {/*#-------------------------------  Cp Route ----------------------------------------------#*/}

      <Route exact path={`${process.env.PUBLIC_URL}/CPdashboard`} component={CPDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/cpform`} component={CPData}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/cpeditform`} component={CPEditForm}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/cpviewform`} component={CPFormView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/CPDGEdashboard`} component={CPDGEDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/CPRegionaldashboard`} component={CPReasonalDashbard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/CPStatedashboard`} component={CPStateDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/cp1report`} component={CP1MisReport}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/cprecheck`} component={RecheckCP}></Route>


      {/* #--------------------------------- ER Route --------------------------------------------------*/}

      <Route exact path={`${process.env.PUBLIC_URL}/ER1`} component={ER1Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ER1-Edit`} component={ER1DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ER2`} component={ER2Data}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ER2-Edit`} component={ER2DataEdit}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ER1-View`} component={ER1DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ER2-View`} component={ER2DataView}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ERDashboard`} component={ERDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ERDGEdashboard`} component={ERDGEDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ERStatedashboard`} component={ERStateDashboard}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/ERRegionaldashboard`} component={ERReasonalDashbard}></Route>


      <Route component={RedirectAs404}></Route>
    </Switch>

  );
};
export default Pages;
